import { render, staticRenderFns } from "./StudentCourseAddAndEdit.vue?vue&type=template&id=5edf24cc"
import script from "./StudentCourseAddAndEdit.vue?vue&type=script&lang=js"
export * from "./StudentCourseAddAndEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports